import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
class CarCategoryAdd extends React.Component {
  state = {
    isData: false,
    id: 0,
    name_en: '',
    name_ar: '',
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  componentDidMount() {
    const id = this.props.match.params.id

    if (id) {
      this.getUpdateData(id)
    }
  }

  getUpdateData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/car/get-car-category/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          const data = res.data.data
          this.setState({
            id: data.id,
            name_en: data.name_en || '',
            name_ar: data.name_ar || '',
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addItem = () => {
    let data = {
      name_en: this.state.name_en,
      name_ar: this.state.name_ar,
    }

    this.setState({ isData: true })
    if (this.props.id) {
      data = {
        ...data,
        id: this.state.id,
      }
      axios
        .put(Constant.getAPI() + '/car/update-car-category', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Category Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/car-category`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/car/create-car-category', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Category Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/car-category`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    if (!this.state.name_en) {
      Swal.fire({
        title: 'Name in English is required',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    } else if (!this.state.name_ar) {
      Swal.fire({
        title: 'Name in Arabic is required',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    this.addItem()
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name in English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    placeholder="Name in English"
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name in Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    placeholder="Name in Arabic"
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/car-category`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(CarCategoryAdd)
